const WOW = require('wow.js'); 
window.wow = new WOW({ live: false });
